import { render, staticRenderFns } from "./CcNodeConfig.vue?vue&type=template&id=2189111f&scoped=true"
import script from "./CcNodeConfig.vue?vue&type=script&lang=js"
export * from "./CcNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./CcNodeConfig.vue?vue&type=style&index=0&id=2189111f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2189111f",
  null
  
)

export default component.exports